<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-add' class='navbarbtn' v-if='showAddPower'
        @click='showAddTableDialogMD()'>
        新 增
      </el-button>

      <el-button type='primary' icon='sys sys-copy' class='navbarbtn'
        v-if='showAddPower' @click='showCopyTableDialogMD()'>
        复 制
      </el-button>

      <el-button type='success' icon='sys sys-sql' class='navbarbtn'
        v-if='showExportMoveSqlPower' @click='exportSql()'>
        导出SQL
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <ComponentTable :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :showOperationsColumn='true' :operationColumnWidth='160'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #expand='scope'>
        <pre class='tableExpand'>{{ scope.data.row.Sql }}</pre>
      </template>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='编辑' placement='top-start' v-if='showEditPower'>
          <el-button type='primary' circle style='padding: 4px;' @click='showUpdateTableDialogMD(scope.data)'><i class='sys sys-edit'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletePower'>
          <el-button type='danger' circle style='padding: 4px;' @click='showDeleteOneTableConfirm(scope.data)'><i class='sys sys-delete'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='默认栏目设置' placement='top-start' v-if='showSetTableColumnPower'>
          <el-button type='primary' circle style='padding: 4px;' @click='showUpdateDefaultColumnDialogMD(scope.data)'><i class='sys sys-columns'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='默认过滤设置' placement='top-start' v-if='showSetTableFilterPower'>
          <el-button type='primary' circle style='padding: 4px;' @click='showUpdateDefaultFilterDialogMD(scope.data)'><i class='sys sys-filter-set'></i></el-button>
        </el-tooltip>
      </template>
    </ComponentTable>

    <!-- 新增表格弹出框 -->
    <el-dialog v-dialogDrag title='添加表格' :visible.sync='showAddTableDialog' width='880px' top='10px' lock-scroll>
      <el-form :model='addTableInfo' label-width='80px' style='margin-top: -20px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='表格编号 ' prop='tableCode' class='formRow mustIn'>
            <el-input v-model='addTableInfo.tableCode' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='表格名称 ' prop='tableName' class='formRow mustIn'>
            <el-input v-model='addTableInfo.tableName' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='表格标题 ' prop='title' class='formRow'>
            <el-input v-model='addTableInfo.title' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='唯一键 ' prop='onlyKey' class='formRow mustIn'>
            <el-input v-model='addTableInfo.onlyKey' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='每页数量 ' prop='pageSize' class='formRow mustIn'>
            <el-input v-model='addTableInfo.pageSize' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='从表1编号 ' prop='detailTableCode1' class='formRow'>
            <el-input v-model='addTableInfo.detailTableCode1' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表2编号 ' prop='detailTableCode2' class='formRow'>
            <el-input v-model='addTableInfo.detailTableCode2' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表3编号 ' prop='detailTableCode3' class='formRow'>
            <el-input v-model='addTableInfo.detailTableCode3' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='从表1外键 ' prop='detailConditionKey1' class='formRow'>
            <el-input v-model='addTableInfo.detailConditionKey1' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表2外键 ' prop='detailConditionKey2' class='formRow'>
            <el-input v-model='addTableInfo.detailConditionKey2' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表3外键 ' prop='detailConditionKey3' class='formRow'>
            <el-input v-model='addTableInfo.detailConditionKey3' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='表格SQL ' prop='sql' class='formRow mustIn'>
            <el-input v-model='addTableInfo.sql' placeholder='必填' type='textarea' :rows='18' style='width: 760px;'></el-input>
          </el-form-item>
        </div>

        <div class='dialogButtomBtn'>
          <el-button type='primary' @click='addTable()' size='mini'>保存</el-button>
          <el-button @click='addTableInfoReset()' size='mini'>重置</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 修改表格弹出框 -->
    <el-dialog v-dialogDrag title='修改表格' :visible.sync='showUpdateTableDialog' width='880px' top='10px' lock-scroll>
      <el-form :model='updateTableInfo' label-width='80px' style='margin-top: -20px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='表格编号 ' prop='tableCode' class='formRow mustIn'>
            <el-input v-model='updateTableInfo.tableCode' placeholder='必填' style='width: 200px;' disabled></el-input>
          </el-form-item>

          <el-form-item label='表格名称 ' prop='tableName' class='formRow mustIn'>
            <el-input v-model='updateTableInfo.tableName' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='表格标题 ' prop='title' class='formRow'>
            <el-input v-model='updateTableInfo.title' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='唯一键 ' prop='onlyKey' class='formRow mustIn'>
            <el-input v-model='updateTableInfo.onlyKey' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='每页数量 ' prop='pageSize' class='formRow mustIn'>
            <el-input v-model='updateTableInfo.pageSize' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='从表1编号 ' prop='detailTableCode1' class='formRow'>
            <el-input v-model='updateTableInfo.detailTableCode1' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表2编号 ' prop='detailTableCode2' class='formRow'>
            <el-input v-model='updateTableInfo.detailTableCode2' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表3编号 ' prop='detailTableCode3' class='formRow'>
            <el-input v-model='updateTableInfo.detailTableCode3' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='从表1外键 ' prop='detailConditionKey1' class='formRow'>
            <el-input v-model='updateTableInfo.detailConditionKey1' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表2外键 ' prop='detailConditionKey2' class='formRow'>
            <el-input v-model='updateTableInfo.detailConditionKey2' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='从表3外键 ' prop='detailConditionKey3' class='formRow'>
            <el-input v-model='updateTableInfo.detailConditionKey3' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='表格SQL ' prop='sql' class='formRow mustIn'>
            <el-input v-model='updateTableInfo.sql' placeholder='必填' type='textarea' :rows='18' style='width: 760px;'></el-input>
          </el-form-item>
        </div>

        <div class='dialogButtomBtn'>
          <el-button type='primary' @click='updateTable()' size='mini'>保存</el-button>
          <el-button @click='updateTableInfoReset()' size='mini'>重置</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 修改默认栏目设置弹出框 -->
    <el-dialog v-dialogDrag title='栏目设置' :visible.sync='showUpdateDefaultColumnDialog' width='75%' top='10px' lock-scroll>
      <el-table :data='oneTableColumnInfo' row-key='ColumnCode' border height='400px'
        :cell-style='tableCellStyle' :header-cell-style='tableHeaderCellStyle' size='medium'
        ref='defaultColumnsTable' v-loading='tableColumnLoading'
        :row-style='columnRowStyle' style='margin-top: -20px;' @row-click='columnRowClick'>
        <el-table-column type='index' label='序号' header-align='center' align='center' width='60' fixed></el-table-column>
        <el-table-column prop='ColumnCode' label='列编号' width='160' fixed></el-table-column>
        <el-table-column prop='ColumnName' label='列名称' width='160' fixed>
          <template #header>
            <span style='color: blue;'>列名称</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode'
              v-model='scope.row.ColumnName' style='width: 140px;' class='tableInput'/>
            <span v-else>{{scope.row.ColumnName}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DisplayFlag' label='是否显示' width='80'>
          <template #header>
            <span style='color: blue;'>是否显示</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.DisplayFlag' style='width: 60px;'>
              <option v-for='displayFlag in columnSpecialStringArrays.displayFlags' :key='displayFlag.code' :value='displayFlag.code'>{{displayFlag.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.DisplayFlag, 'DisplayFlag')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Seq' label='显示顺序' width='80'>
          <template #header>
            <span style='color: blue;'>显示顺序</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "Seq")'
              v-model='scope.row.Seq' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.Seq}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Width' label='宽度' width='80'>
          <template #header>
            <span style='color: blue;'>宽度</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "Width")'
              v-model='scope.row.Width' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.Width}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DataType' label='数据类型' width='120'>
          <template #header>
            <span style='color: blue;'>数据类型</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.DataType' style='width: 100px;'>
              <option v-for='dataType in columnSpecialStringArrays.dataTypes' :key='dataType.code' :value='dataType.code'>{{dataType.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.DataType, 'DataType')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='CustomDisplay' label='自定义显示' width='100'>
          <template #header>
            <span style='color: blue;'>自定义显示</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.CustomDisplay' style='width: 80px;'>
              <option v-for='customDisplay in columnSpecialStringArrays.customDisplays' :key='customDisplay.code' :value='customDisplay.code'>{{customDisplay.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.CustomDisplay, 'CustomDisplay')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='TextAlign' label='对齐方式' width='100'>
          <template #header>
            <span style='color: blue;'>对齐方式</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.TextAlign' style='width: 80px;'>
              <option v-for='textAlign in columnSpecialStringArrays.textAligns' :key='textAlign.code' :value='textAlign.code'>{{textAlign.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.TextAlign, 'TextAlign')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DateFormat' label='日期格式' width='180'>
          <template #header>
            <span style='color: blue;'>日期格式</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode'
              v-model='scope.row.DateFormat' style='width: 160px;' class='tableInput'/>
            <span v-else>{{scope.row.DateFormat}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Color' label='颜色' width='120'>
          <template #header>
            <span style='color: blue;'>颜色</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode'
              v-model='scope.row.Color' style='width: 100px;' class='tableInput'/>
            <span v-else>{{scope.row.Color}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DecimalDigits' label='小数位数' width='80'>
          <template #header>
            <span style='color: blue;'>小数位数</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "DecimalDigits")'
              v-model='scope.row.DecimalDigits' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.DecimalDigits}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='OrderType' label='排序方式' width='100'>
          <template #header>
            <span style='color: blue;'>排序方式</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.OrderType' style='width: 80px;'>
              <option v-for='orderType in columnSpecialStringArrays.orderTypes' :key='orderType.code' :value='orderType.code'>{{orderType.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.OrderType, 'OrderType')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='OrderSeq' label='排序序号' width='80'>
          <template #header>
            <span style='color: blue;'>排序序号</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "OrderSeq")'
              v-model='scope.row.OrderSeq' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.OrderSeq}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='FixedFlag' label='固定位置' width='100'>
          <template #header>
            <span style='color: blue;'>固定位置</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.FixedFlag' style='width: 80px;'>
              <option v-for='fixedFlag in columnSpecialStringArrays.fixedFlags' :key='fixedFlag.code' :value='fixedFlag.code'>{{fixedFlag.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.FixedFlag, 'FixedFlag')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Sortable' label='是否可排序' width='100'>
          <template #header>
            <span style='color: blue;'>是否可排序</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.Sortable' style='width: 80px;'>
              <option v-for='sortable in columnSpecialStringArrays.sortables' :key='sortable.code' :value='sortable.code'>{{sortable.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.Sortable, 'Sortable')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='ShowOverflowTooltip' label='是否显示Tip' width='120'>
          <template #header>
            <span style='color: blue;'>是否显示Tip</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.ShowOverflowTooltip' style='width: 100px;'>
              <option v-for='showOverflowTooltip in columnSpecialStringArrays.showOverflowTooltips' :key='showOverflowTooltip.code' :value='showOverflowTooltip.code'>{{showOverflowTooltip.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.ShowOverflowTooltip, 'ShowOverflowTooltip')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Description' label='列描述' width='200' show-overflow-tooltip>
          <template #header>
            <span style='color: blue;'>列描述</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode'
              v-model='scope.row.Description' style='width: 180px;' class='tableInput'/>
            <span v-else>{{scope.row.Description}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class='dialogButtomBtn'>
        <el-select v-model='oneTableInfo.PageSize' placeholder='每页数量'
          style='width:100px; margin-right:20px;' size='mini'>
          <el-option v-for='pageSize in pageSizes' :key='pageSize' :label='pageSize' :value='pageSize'>
          </el-option>
        </el-select>
        <el-button type='primary' @click='saveDefaultTableColumn()' size='mini'>保存</el-button>
        <el-button @click='defaultTableColumnsReSort()' size='mini'>排序</el-button>
        <el-button @click='showUpdateDefaultColumnDialogMD({ row: { TableCode: oneTableInfo.TableCode } })' size='mini'>重置</el-button>
      </div>
    </el-dialog>

    <!-- 修改默认过滤设置弹出框 -->
    <el-dialog v-dialogDrag title='过滤设置' :visible.sync='showUpdateDefaultFilterDialog' width='75%' top='10px' lock-scroll>
      <el-table :data='oneTableFilterInfo' border height='400px' v-loading='tableFilterLoading'
        :cell-style='tableCellStyle' :header-cell-style='tableHeaderCellStyle' size='medium'
        style='margin-top: -20px;'>
        <el-table-column type='index' label='序号' header-align='center' align='center' width='60' fixed></el-table-column>
        <el-table-column prop='ColumnCode' label='列名称' width='160' fixed>
          <template #header>
            <span style='color: blue;'>列名称</span>
          </template>
          <template #default='scope'>
            <select class='tableInput' v-model='scope.row.ColumnCode' style='width: 140px;'
              @change='filterColumnChange(scope)'>
              <option v-for='column in oneTableColumnInfo' :key='column.ColumnCode' :value='column.ColumnCode'>{{column.ColumnName}}</option>
            </select>
          </template>
        </el-table-column>
        <el-table-column prop='FilterType' label='过滤类型' width='100'>
          <template #header>
            <span style='color: blue;'>过滤类型</span>
          </template>
          <template #default='scope'>
            <select class='tableInput' v-if='scope.row.DataType === "0"' v-model='scope.row.FilterType' style='width: 80px;'>
              <option v-for='filterType in filterSpecialStringArrays.filterTypes0' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
            </select>
            <select class='tableInput' v-if='scope.row.DataType === "1"' v-model='scope.row.FilterType' style='width: 80px;'>
              <option v-for='filterType in filterSpecialStringArrays.filterTypes1' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
            </select>
            <select class='tableInput' v-if='scope.row.DataType === "2"' v-model='scope.row.FilterType' style='width: 80px;'>
              <option v-for='filterType in filterSpecialStringArrays.filterTypes2' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
            </select>
            <select class='tableInput' v-if='scope.row.DataType === "3"' v-model='scope.row.FilterType' style='width: 80px;'>
              <option v-for='filterType in filterSpecialStringArrays.filterTypes3' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
            </select>
            <select class='tableInput' v-if='scope.row.DataType === "4"' v-model='scope.row.FilterType' style='width: 80px;'>
              <option v-for='filterType in filterSpecialStringArrays.filterTypes4' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
            </select>
            <select class='tableInput' v-if='scope.row.DataType === "5"' v-model='scope.row.FilterType' style='width: 80px;'>
              <option v-for='filterType in filterSpecialStringArrays.filterTypes5' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
            </select>
          </template>
        </el-table-column>
        <el-table-column prop='Type' label='条件类型' width='80'>
          <template #header>
            <span style='color: blue;'>条件类型</span>
          </template>
          <template #default='scope'>
            <select class='tableInput' v-model='scope.row.Type' style='width: 60px;'>
              <option v-for='type in filterSpecialStringArrays.types' :key='type.code' :value='type.code'>{{type.name}}</option>
            </select>
          </template>
        </el-table-column>
        <el-table-column prop='DataType' label='数据类型' width='100'>
          <template #default='scope'>
            <span>{{filterSpecialStringDisplayTransform(scope.row.DataType, 'DataType')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop='OutDisplay' label='外部显示' width='80'>
          <template #header>
            <span style='color: blue;'>外部显示</span>
          </template>
          <template #default='scope'>
            <select class='tableInput' v-model='scope.row.OutDisplay' style='width: 60px;'>
              <option v-for='outDisplay in filterSpecialStringArrays.outDisplays' :key='outDisplay.code' :value='outDisplay.code'>{{outDisplay.name}}</option>
            </select>
          </template>
        </el-table-column>
        <el-table-column prop='DateFormat' label='日期格式' width='140'>
          <template #header>
            <span style='color: blue;'>日期格式</span>
          </template>
          <template #default='scope'>
            <select class='tableInput' v-if='scope.row.DataType === "4"' v-model='scope.row.DateFormat' style='width: 120px;'>
              <option v-for='dateFormat in filterSpecialStringArrays.dateFormats' :key='dateFormat.code' :value='dateFormat.code'>{{dateFormat.name}}</option>
            </select>
          </template>
        </el-table-column>
        <el-table-column prop='DefaultVal1Type' label='默认值1类型' width='100'>
          <template #header>
            <span style='color: blue;'>默认值1类型</span>
          </template>
          <template #default='scope'>
            <select class='tableInput' v-model='scope.row.DefaultVal1Type' style='width: 80px;'>
              <option v-for='defaultValType in filterSpecialStringArrays.defaultValTypes' :key='defaultValType.code' :value='defaultValType.code'>{{defaultValType.name}}</option>
            </select>
          </template>
        </el-table-column>
        <el-table-column prop='DefaultVal1' label='默认值1' width='140'>
          <template #header>
            <span style='color: blue;'>默认值1</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.DefaultVal1Type === "0"' v-model='scope.row.DefaultVal1' style='width: 120px;' class='tableInput'/>
          </template>
        </el-table-column>
        <el-table-column prop='DefaultVal2Type' label='默认值2类型' width='100'>
          <template #header>
            <span style='color: blue;'>默认值2类型</span>
          </template>
          <template #default='scope'>
            <select class='tableInput' v-model='scope.row.DefaultVal2Type' style='width: 80px;'>
              <option v-for='defaultValType in filterSpecialStringArrays.defaultValTypes' :key='defaultValType.code' :value='defaultValType.code'>{{defaultValType.name}}</option>
            </select>
          </template>
        </el-table-column>
        <el-table-column prop='DefaultVal2' label='默认值2' width='140'>
          <template #header>
            <span style='color: blue;'>默认值2</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.DefaultVal2Type === "0"' v-model='scope.row.DefaultVal2' style='width: 120px;' class='tableInput'/>
          </template>
        </el-table-column>

        <el-table-column label='操作' width='120' fixed='right'>
          <template #default='scope'>
            <el-tooltip effect='dark' content='删除该行' placement='top-start'>
              <el-button type='danger' circle style='padding: 4px;' @click='deleteOneFilter(scope.$index)'><i class='sys sys-delete'></i></el-button>
            </el-tooltip>
            <el-tooltip effect='dark' content='上移' placement='top-start'>
              <el-button type='primary' circle style='padding: 4px;' @click='upOneFilter(scope.$index)'><i class='sys sys-box-up'></i></el-button>
            </el-tooltip>
            <el-tooltip effect='dark' content='下移' placement='top-start'>
              <el-button type='primary' circle style='padding: 4px;' @click='downOneFilter(scope.$index)'><i class='sys sys-box-down'></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class='dialogButtomBtn'>
        <el-button type='primary' @click='addOneFilterType()' size='mini'>添加行</el-button>
        <el-button type='primary' @click='saveDefaultTableFilter()' size='mini'>保存</el-button>
        <el-button @click='updateDefaultFilterDialogReset()' size='mini'>重置</el-button>
      </div>
    </el-dialog>

    <!-- 表格复制弹出框 -->
    <el-dialog v-dialogDrag title='复制表格' :visible.sync='showCopyTableDialog' width='340px' top='10px' lock-scroll>
      <el-form :model='copyTable' label-width='100px' style='margin-top: -20px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='复制表格编号 ' prop='oldTableCode' class='formRow mustIn'>
            <el-input v-model='copyTable.oldTableCode' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='新增表格表格 ' prop='newTableCode' class='formRow mustIn'>
            <el-input v-model='copyTable.newTableCode' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='dialogButtomBtn-center'>
          <el-button type='primary' @click='copyTableMD()' size='medium'>复制</el-button>
          <el-button @click='showCopyTableDialog = false' size='medium'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'

export default {
  name: 'Table',
  components: {
    ComponentTable: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'SYS_Table',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: []
      },
      pageSizes: [10, 20, 50, 100, 200],
      columnSpecialStringArrays: {
        dataTypes: [],
        displayFlags: [],
        textAligns: [],
        customDisplays: [],
        orderTypes: [],
        fixedFlags: [],
        sortables: [],
        showOverflowTooltips: []
      },

      showAddTableDialog: false,
      addTableInfo: {
        tableCode: '',
        tableName: '',
        sql: '',
        title: '',
        onlyKey: '',
        pageSize: '',
        detailTableCode1: '',
        detailConditionKey1: '',
        detailTableCode2: '',
        detailConditionKey2: '',
        detailTableCode3: '',
        detailConditionKey3: ''
      },

      showUpdateTableDialog: false,
      updateTableInfo: {
        tableCode: '',
        tableName: '',
        sql: '',
        title: '',
        onlyKey: '',
        pageSize: '',
        detailTableCode1: '',
        detailConditionKey1: '',
        detailTableCode2: '',
        detailConditionKey2: '',
        detailTableCode3: '',
        detailConditionKey3: ''
      },
      updateTableOldInfo: {},

      showUpdateDefaultColumnDialog: false,
      tableColumnLoading: false,
      oneTableInfo: {},
      oneTableColumnInfo: [],
      editColumnCode: '',

      filterSpecialStringArrays: {
        dataTypes: [],
        types: [],
        defaultValTypes: [],
        outDisplays: [],
        dateFormats: [],
        filterTypes0: [],
        filterTypes1: [],
        filterTypes2: [],
        filterTypes3: [],
        filterTypes4: [],
        filterTypes5: []
      },
      showUpdateDefaultFilterDialog: false,
      tableFilterLoading: false,
      oneTableFilterInfo: [],
      filterTableCode: '',

      showCopyTableDialog: false,
      copyTable: {
        oldTableCode: '',
        newTableCode: ''
      },

      showAddPower: false,
      showEditPower: false,
      showDeletePower: false,
      showSetTableColumnPower: false,
      showSetTableFilterPower: false,
      showExportMoveSqlPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.columnSpecialStringArrays.dataTypes = code.getCode(codes, 'SYS_Table_DataType')
    that.columnSpecialStringArrays.displayFlags = code.getCode(codes, 'SYS_Table_DisplayFlag')
    that.columnSpecialStringArrays.textAligns = code.getCode(codes, 'SYS_Table_TextAlign')
    that.columnSpecialStringArrays.customDisplays = code.getCode(codes, 'SYS_Table_CustomDisplay')
    that.columnSpecialStringArrays.orderTypes = code.getCode(codes, 'SYS_Table_OrderType')
    that.columnSpecialStringArrays.fixedFlags = code.getCode(codes, 'SYS_Table_FixedFlag')
    that.columnSpecialStringArrays.sortables = code.getCode(codes, 'SYS_Table_Sortable')
    that.columnSpecialStringArrays.showOverflowTooltips = code.getCode(codes, 'SYS_Table_ShowOverflowTooltip')
    that.filterSpecialStringArrays.dataTypes = code.getCode(codes, 'SYS_TableFilter_DataType')
    that.filterSpecialStringArrays.types = code.getCode(codes, 'SYS_TableFilter_Type')
    that.filterSpecialStringArrays.defaultValTypes = code.getCode(codes, 'SYS_TableFilter_DefaultValType')
    that.filterSpecialStringArrays.outDisplays = code.getCode(codes, 'SYS_TableFilter_OutDisplay')
    that.filterSpecialStringArrays.filterTypes0 = code.getCode(codes, 'SYS_TableFilter_FilterType0')
    that.filterSpecialStringArrays.filterTypes1 = code.getCode(codes, 'SYS_TableFilter_FilterType1')
    that.filterSpecialStringArrays.filterTypes2 = code.getCode(codes, 'SYS_TableFilter_FilterType2')
    that.filterSpecialStringArrays.filterTypes3 = code.getCode(codes, 'SYS_TableFilter_FilterType3')
    that.filterSpecialStringArrays.filterTypes4 = code.getCode(codes, 'SYS_TableFilter_FilterType4')
    that.filterSpecialStringArrays.filterTypes5 = code.getCode(codes, 'SYS_TableFilter_FilterType5')
    that.filterSpecialStringArrays.dateFormats = code.getCode(codes, 'SYS_TableFilter_DateFormat')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 新增表格弹出框显示方法
    showAddTableDialogMD: function () {
      const that = this
      that.showAddTableDialog = true
      that.addTableInfoReset()
    },

    // 新增表格弹出框数据重置方法
    addTableInfoReset: function () {
      const that = this
      that.addTableInfo.tableCode = ''
      that.addTableInfo.tableName = ''
      that.addTableInfo.title = ''
      that.addTableInfo.sql = ''
      that.addTableInfo.onlyKey = ''
      that.addTableInfo.pageSize = 50
      that.addTableInfo.detailTableCode1 = ''
      that.addTableInfo.detailConditionKey1 = ''
      that.addTableInfo.detailTableCode2 = ''
      that.addTableInfo.detailConditionKey2 = ''
      that.addTableInfo.detailTableCode3 = ''
      that.addTableInfo.detailConditionKey3 = ''
    },

    // 新增表格
    addTable: async function () {
      const that = this
      if (!that.addTableInfo.tableCode) {
        that.$message.error('请输入表格编号！')
        return
      }
      if (!that.addTableInfo.tableName) {
        that.$message.error('请输入表格名称！')
        return
      }
      if (!that.addTableInfo.onlyKey) {
        that.$message.error('请输入唯一键！')
        return
      }
      if (!that.addTableInfo.pageSize) {
        that.$message.error('请输入每页数量！')
        return
      }
      if (!that.addTableInfo.sql) {
        that.$message.error('请输入sql！')
        return
      }
      if (that.addTableInfo.detailTableCode1 && !that.addTableInfo.detailConditionKey1) {
        that.$message.error('请输入从表1外键！')
        return
      }
      if (that.addTableInfo.detailTableCode2 && !that.addTableInfo.detailConditionKey2) {
        that.$message.error('请输入从表2外键！')
        return
      }
      if (that.addTableInfo.detailTableCode3 && !that.addTableInfo.detailConditionKey3) {
        that.$message.error('请输入从表3外键！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.AddTable', that.addTableInfo)
      if (rtnObj.error === '000000') {
        that.showAddTableDialog = false
        that.refreshMainTableContent()
        that.$message.success('恭喜你，新增表格成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 修改表格弹出框显示方法
    showUpdateTableDialogMD: function (scope) {
      const that = this
      that.showUpdateTableDialog = true
      that.updateTableOldInfo = scope.row
      that.updateTableInfoReset()
    },

    // 修改表格弹出框数据重置方法
    updateTableInfoReset: function () {
      const that = this
      that.updateTableInfo.tableCode = that.updateTableOldInfo.TableCode
      that.updateTableInfo.tableName = that.updateTableOldInfo.TableName
      that.updateTableInfo.title = that.updateTableOldInfo.Title
      that.updateTableInfo.onlyKey = that.updateTableOldInfo.OnlyKey
      that.updateTableInfo.pageSize = that.updateTableOldInfo.PageSize
      that.updateTableInfo.sql = that.updateTableOldInfo.Sql
      that.updateTableInfo.detailTableCode1 = that.updateTableOldInfo.DetailTableCode1
      that.updateTableInfo.detailConditionKey1 = that.updateTableOldInfo.DetailConditionKey1
      that.updateTableInfo.detailTableCode2 = that.updateTableOldInfo.DetailTableCode2
      that.updateTableInfo.detailConditionKey2 = that.updateTableOldInfo.DetailConditionKey2
      that.updateTableInfo.detailTableCode3 = that.updateTableOldInfo.DetailTableCode3
      that.updateTableInfo.detailConditionKey3 = that.updateTableOldInfo.DetailConditionKey3
      that.updateTableInfo.timeStamp = that.updateTableOldInfo.TimeStamp
    },

    // 修改表格
    updateTable: async function () {
      const that = this
      if (!that.updateTableInfo.tableCode) {
        that.$message.error('请输入表格编号！')
        return
      }
      if (!that.updateTableInfo.tableName) {
        that.$message.error('请输入表格名称！')
        return
      }
      if (!that.updateTableInfo.onlyKey) {
        that.$message.error('请输入唯一键！')
        return
      }
      if (!that.updateTableInfo.pageSize) {
        that.$message.error('请输入每页数量！')
        return
      }
      if (!that.updateTableInfo.sql) {
        that.$message.error('请输入sql！')
        return
      }
      if (that.updateTableInfo.detailTableCode1 && !that.updateTableInfo.detailConditionKey1) {
        that.$message.error('请输入从表1外键！')
        return
      }
      if (that.updateTableInfo.detailTableCode2 && !that.updateTableInfo.detailConditionKey2) {
        that.$message.error('请输入从表2外键！')
        return
      }
      if (that.updateTableInfo.detailTableCode3 && !that.updateTableInfo.detailConditionKey3) {
        that.$message.error('请输入从表3外键！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.UpdateTable', that.updateTableInfo)
      if (rtnObj.error === '000000') {
        that.showUpdateTableDialog = false
        that.refreshMainTableContent()
        that.$message.success('恭喜你，修改表格成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除表格确认弹出框
    showDeleteOneTableConfirm: function (scope) {
      const that = this
      that.$confirm('此操作将永久删除该表格【' + scope.row.TableCode + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteOneTable(scope.row.TableCode)
      }).catch(() => {
      })
    },

    // 删除一个表格
    deleteOneTable: async function (tableCode) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.DeleteTable', {
        tableCode: tableCode
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，删除表格信息成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 显示修改表格默认栏目设置弹出框方法
    showUpdateDefaultColumnDialogMD: function (scope) {
      const that = this
      that.showUpdateDefaultColumnDialog = true
      that.getOneTableInfoAndDefaultColumnInfo(scope.row.TableCode)
    },

    // 获取某表格默认栏目设置信息
    getOneTableInfoAndDefaultColumnInfo: async function (tableCode) {
      const that = this
      that.tableColumnLoading = true
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.GetDefaultTableColumns', {
        tableCode: tableCode
      })
      if (rtnObj.error === '000000') {
        that.oneTableColumnInfo = rtnObj.tableColumns
        that.oneTableInfo = rtnObj.tableInfo[0]
      } else {
        that.$message.error(rtnObj.msg)
      }
      that.editColumnCode = ''
      that.tableColumnLoading = false
    },

    // 表格默认栏目设置弹出框表格行单机事件
    columnRowClick: function (row, event, column) {
      const that = this
      that.editColumnCode = row.ColumnCode
    },

    // 表格默认栏目设置弹出框表格特征字符串转义显示方法
    columnSpecialStringDisplayTransform: function (val, columnCode) {
      const that = this
      if (columnCode === 'DisplayFlag') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.displayFlags)
      } else if (columnCode === 'DataType') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.dataTypes)
      } else if (columnCode === 'CustomDisplay') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.customDisplays)
      } else if (columnCode === 'TextAlign') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.textAligns)
      } else if (columnCode === 'OrderType') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.orderTypes)
      } else if (columnCode === 'FixedFlag') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.fixedFlags)
      } else if (columnCode === 'Sortable') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.sortables)
      } else if (columnCode === 'ShowOverflowTooltip') {
        return table.specialStringDisplayTransform(val, that.columnSpecialStringArrays.showOverflowTooltips)
      }
    },

    // 数字输入框值改变方法
    numberChange: function (row, code) {
      try {
        row[code] = parseFloat(row[code])
        if (isNaN(row[code])) {
          row[code] = 0
        }
      } catch (err) {
        row[code] = 0
      }
    },

    // 表格默认栏目设置排序方法
    defaultTableColumnsReSort: function () {
      const that = this
      for (let i = 0; i < that.oneTableColumnInfo.length; i++) {
        for (let j = i; j < that.oneTableColumnInfo.length; j++) {
          if ((that.oneTableColumnInfo[i].DisplayFlag === that.oneTableColumnInfo[j].DisplayFlag &&
            parseInt(that.oneTableColumnInfo[i].Seq) > parseInt(that.oneTableColumnInfo[j].Seq)) ||
            (that.oneTableColumnInfo[j].DisplayFlag === '1' && that.oneTableColumnInfo[i].DisplayFlag === '0')) {
            const tempRow = that.oneTableColumnInfo[i]
            that.oneTableColumnInfo[i] = that.oneTableColumnInfo[j]
            that.oneTableColumnInfo[j] = tempRow
          }
        }
      }
      for (let i = 0; i < that.oneTableColumnInfo.length; i++) {
        that.oneTableColumnInfo[i].Seq = i + 1
      }
      that.$refs.defaultColumnsTable.doLayout()
    },

    // 表格默认栏目设置保存方法
    saveDefaultTableColumn: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.SaveTableColumnSettings', {
        columnsInfo: that.oneTableColumnInfo,
        tableCode: that.oneTableInfo.TableCode,
        pageSize: that.oneTableInfo.PageSize
      })
      if (rtnObj.error === '000000') {
        that.showUpdateDefaultColumnDialog = false
        that.refreshMainTableContent()
        that.$message.success('恭喜你，保存默认栏目设置成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格默认栏目设置行样式设定方法
    columnRowStyle: function (row, rowIndex) {
      if (row.row.DisplayFlag === '0') {
        return { 'background-color': '#CCCCCC' }
      } else {
        return { 'background-color': '#FFFFFF' }
      }
    },

    // 页面主表格默认过滤设置弹出框表格特征字符串转义显示方法
    filterSpecialStringDisplayTransform: function (val, columnCode) {
      const that = this
      if (columnCode === 'DataType') {
        return table.specialStringDisplayTransform(val, that.filterSpecialStringArrays.dataTypes)
      }
    },

    // 页面主表格默认过滤设置弹框显示方法
    showUpdateDefaultFilterDialogMD: function (scope) {
      const that = this
      that.showUpdateDefaultFilterDialog = true
      that.filterTableCode = scope.row.TableCode
      that.getOneTableInfoAndDefaultColumnInfo(scope.row.TableCode)
      that.getOneDefaultFilterInfo()
    },

    // 获取表格默认过滤设置
    getOneDefaultFilterInfo: async function () {
      const that = this
      that.tableFilterLoading = true
      const rtnObj = await axiosHelper.handle('/WebSYSAction/TableFilter.GetDefaultTableFilters', {
        tableCode: that.filterTableCode
      })
      if (rtnObj.error === '000000') {
        that.oneTableFilterInfo = rtnObj.tableFilters
      } else {
        that.$message.error(rtnObj.msg)
      }
      that.tableFilterLoading = false
    },

    // 页面主表格默认过滤设置弹框表格列名称选择方法
    filterColumnChange: function (scope) {
      const that = this
      for (let i = 0; i < that.oneTableColumnInfo.length; i++) {
        if (that.oneTableColumnInfo[i].ColumnCode === scope.row.ColumnCode) {
          scope.row.DataType = that.oneTableColumnInfo[i].DataType
          if (scope.row.DataType === '0') {
            scope.row.FilterType = '10'
            scope.row.DateFormat = ''
          } else if (scope.row.DataType === '1') {
            scope.row.FilterType = '00'
            scope.row.DateFormat = ''
          } else if (scope.row.DataType === '2') {
            scope.row.FilterType = '00'
            scope.row.DateFormat = ''
          } else if (scope.row.DataType === '3') {
            scope.row.FilterType = '00'
            scope.row.DateFormat = ''
          } else if (scope.row.DataType === '4') {
            scope.row.FilterType = '00'
            scope.row.DateFormat = 'yyyy-MM-dd'
          } else if (scope.row.DataType === '5') {
            scope.row.FilterType = '00'
            scope.row.DateFormat = ''
          }
        }
      }
    },

    // 页面主表格默认过滤设置弹框表格行添加方法
    addOneFilterType: function () {
      const that = this
      that.oneTableFilterInfo.push({
        ColumnCode: '',
        FilterType: '',
        Type: '1',
        DataType: '',
        DateFormat: '',
        DefaultVal1Type: '0',
        DefaultVal1: '',
        DefaultVal2Type: '0',
        DefaultVal2: '',
        OutDisplay: '0'
      })
    },

    // 页面主表格默认过滤设置弹框表格行删除方法
    deleteOneFilter: function (index) {
      const that = this
      that.oneTableFilterInfo.splice(index, 1)
    },

    // 页面主表格默认过滤设置弹框表格行上移方法
    upOneFilter: function (index) {
      if (index === 0) return
      const that = this
      that.oneTableFilterInfo[index - 1] = [that.oneTableFilterInfo[index], that.oneTableFilterInfo[index] = that.oneTableFilterInfo[index - 1]][0]
      that.oneTableFilterInfo.splice(0, 0)
    },

    // 页面主表格默认过滤设置弹框表格行下移方法
    downOneFilter: function (index) {
      const that = this
      if (index === that.oneTableFilterInfo.length - 1) return
      that.oneTableFilterInfo[index] = [that.oneTableFilterInfo[index + 1], that.oneTableFilterInfo[index + 1] = that.oneTableFilterInfo[index]][0]
      that.oneTableFilterInfo.splice(0, 0)
    },

    // 页面主表格默认过滤设置弹框表格重置方法
    updateDefaultFilterDialogReset: function () {
      const that = this
      that.getOneDefaultFilterInfo(that.oneTableInfo.TableCode)
    },

    // 判断数组中是否有相同的值（对对象数组无效）
    checkArrayHaveSameValue (ary) {
      const newAry = ary.sort()
      for (let i = 0; i < newAry.length - 1; i++) {
        if (newAry[i] === newAry[i + 1]) {
          return true
        }
      }
      return false
    },

    // 页面主表格默认过滤设置弹框表格保存方法
    saveDefaultTableFilter: async function () {
      const that = this
      const newAry = []
      for (let i = 0; i < that.oneTableFilterInfo.length; i++) {
        if (!that.oneTableFilterInfo[i].ColumnCode) {
          that.$message.warning('列名称不能为空！')
          return
        }
        if (!that.oneTableFilterInfo[i].FilterType) {
          that.$message.warning('过滤类型不能为空！')
          return
        }
        newAry.push(that.oneTableFilterInfo[i].ColumnCode + '------' + that.oneTableFilterInfo[i].FilterType)
      }
      if (that.checkArrayHaveSameValue(newAry)) {
        that.$message.warning('列名称和过滤类型的组合不能重复！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/TableFilter.SaveTableFilterSettings', {
        filtersInfo: that.oneTableFilterInfo,
        tableCode: that.filterTableCode
      })
      if (rtnObj.error === '000000') {
        that.showUpdateDefaultFilterDialog = false
        that.$message.success('恭喜你，保存默认过滤设置成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 复制表格弹出框
    showCopyTableDialogMD: function () {
      this.showCopyTableDialog = true
      this.copyTable.oldTableCode = ''
      this.copyTable.newTableCode = ''
    },

    // 复制表格
    copyTableMD: async function () {
      const that = this
      if (that.copyTable.oldTableCode === '') {
        that.$message.error('请输入复制表格编号！')
        return
      }
      if (that.copyTable.newTableCode === '') {
        that.$message.error('请输入新增表格编号！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.CopyTable', that.copyTable)
      if (rtnObj.error === '000000') {
        that.showCopyTableDialog = false
        that.refreshMainTableContent()
        that.$message.success('恭喜你，复制表格成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 导出Sql
    exportSql: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.ExportSql', {
        selections: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        let consoleStr = ''
        for (let i = 0; i < rtnObj.sqlList.length; i++) {
          consoleStr += rtnObj.sqlList[i]
        }
        console.log(consoleStr)
        that.$message.success('恭喜你，导出成功，请到控制台查看！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格单元格样式
    tableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    tableHeaderCellStyle: function () {
      return { padding: '0px', 'background-color': '#f5f7fa' }
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.hbox {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.formRow {
  margin-top: 2px;
  margin-bottom: 3px;
}
.dialogButtomBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tableExpand {
  width: 1200px;
  font-size: 16px;
  border-left: 1px solid #eeeeee;
  padding-left: 10px;
  color: #99a9bf;
  margin: 5px 45px;
}
.tableInput {
  height: 20px;
  line-height: 20px;
  border: 0;
  background-color: transparent;
  padding: 0;
}
.dialogButtomBtn-center {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
